import React from "react";
import { useTranslation } from "react-i18next";
import ReportingTabs from "./ReportingTabs";
import { ColumnHeading } from "@/shared/components/TableElements";
import { StatusContainer } from "../../shared/components/TableElements";
import aiPoweredIcon from "@/shared/img/ai-powered-icon.png";
import styled from "styled-components";

const Reporting = () => {
  const { t } = useTranslation("common");
  return (
    <div className="mx-4">
      <div
        className="d-flex justify-content-between"
        style={{ padding: "0 0.5rem 0.65rem 0.5rem" }}
      >
        <div
          className="d-flex align-items-center gap-2"
          //style={{ padding: "0 0.5rem 0.5rem 0.5rem" }}
        >
          <ColumnHeading>{t("reporting")}</ColumnHeading>
          {/* <StatusContainer background={"#FCE3AB"}>
            <p style={{ color: "black" }}>{t("beta")}</p>
          </StatusContainer> */}
        </div>

        <div
          className="d-flex gap-1"
          //style={{ padding: "0 0.5rem 0.5rem 0.5rem" }}
        >
          <img
            src={aiPoweredIcon}
            alt="ai-powered-icon"
            width={16}
            height={16}
            style={{ position: "relative", top: "2px" }}
          />
          <GradientText>{t("ai_powered")}</GradientText>
        </div>
      </div>
      <ReportingTabs />
    </div>
  );
};

export default Reporting;

const GradientText = styled.p`
  background: linear-gradient(to right, #a855f7, #3b82f6); /* purple to blue */
  //background: linear-gradient(135deg, #853BE1 , #3761E3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 500;
  font-size: 14px;
`;
